/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


$('.AnnouncementBar__Wrapper.slider').flickity({
  // options
  wrapAround: true,
  autoPlay: true,
  autoPlay: 4500,
  prevNextButtons: false,
  pageDots: false,
  percentPosition: false
});



$('.quickshop-button, .quickshop-button-small').click(function(e){ 
  e.preventDefault();
  
  $('.PageOverlay').addClass('is-visible');
  
  $('.ProductItem__Wrapper').addClass('no-hover');
  
  $('html').addClass('no-scroll');
  
  var productID = $(this).attr("data-product-id");
  
//   console.log('1 ' + productID);
  
  $('.quickshop-popup[data-product-id="' + productID + '"]').addClass('show');
  
  $('.quickshop-popup .Drawer__Close, .PageOverlay.is-visible').click(function(){ 
    $('.quickshop-popup').removeClass('show');  
    $('.PageOverlay').removeClass('is-visible');
    $('.ProductItem__Wrapper').removeClass('no-hover');  
    $('html').removeClass('no-scroll');
  });
  
});

$(document).on('click', '.quickshop-button', function(e) {
  
  e.preventDefault();
  
  
  $('.PageOverlay').addClass('is-visible');
  
  $('.ProductItem__Wrapper').addClass('no-hover');
  
  $('html').addClass('no-scroll');
  
  var productID = $(this).attr("data-product-id");
  
//   console.log('2 ' + productID);
  
  $('.quickshop-popup[data-product-id="' + productID + '"]').addClass('show');
  
  $('.quickshop-popup .Drawer__Close, .PageOverlay.is-visible').click(function(){ 
    $('.quickshop-popup').removeClass('show');  
    $('.PageOverlay').removeClass('is-visible');
    $('.ProductItem__Wrapper').removeClass('no-hover');  
    $('html').removeClass('no-scroll');
  });
  
});

$('body').on('click', '.quickshop-button-small', function(e) {
  e.preventDefault();
  
  $('.PageOverlay').addClass('is-visible');
  
  $('.ProductItem__Wrapper').addClass('no-hover');
  
  $('html').addClass('no-scroll');
  
  var productID = $(this).attr("data-product-id");
  
//   console.log('3 ' + productID);
  
  $('.quickshop-popup[data-product-id="' + productID + '"]').addClass('show');
  
  $('.quickshop-popup .Drawer__Close, .PageOverlay.is-visible').click(function(){ 
    $('.quickshop-popup').removeClass('show');  
    $('.PageOverlay').removeClass('is-visible');
    $('.ProductItem__Wrapper').removeClass('no-hover');  
    $('html').removeClass('no-scroll');
  });
  
});



$(document).ready(function() {
  $('.ProductItem__ImageWrapper--withAlternateImage').on('touchstart touchend', function(e) {
//     e.preventDefault();
    $(this).find('.ProductItem__Image:not(.ProductItem__Image--alternate)').toggleClass('hover_effect');
    $(this).find('.ProductItem__Image--alternate').toggleClass('hover_effect');
    console.log('alternate');
  });
  
  $('.has-megamenu').click(function(e){ 
    e.preventDefault();
  });
});


(() => {
    /**
     *
     * @param {string} selector
     * @returns {Promise<HTMLDivElement>}
     */
    function waitForElm(selector) {
        console.log('waiting for elem ' + selector);
        return new Promise((resolve) => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }

            const observer = new MutationObserver((mutations) => {
                if (document.querySelector(selector)) {
                    resolve(document.querySelector(selector));
                    observer.disconnect();
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true,
            });
        });
    }

    waitForElm('button[name="checkout"]').then((el) => {
        if (!document.body.classList.contains('cleever-on')) {
            return
        }
        el.addEventListener('click', window.cleeverCheckouthandleClick)
        const new_element = el.cloneNode(true);
        new_element.addEventListener('click', window.cleeverCheckouthandleClick)
        el.parentNode.replaceChild(new_element, el);
        let i = 0;
        let interval = setInterval(() => {
            i++
            const el = document.querySelector('button[name="checkout"]')
            console.log('set interval running')
            const new_element = el.cloneNode(true);
            el.parentNode.replaceChild(new_element, el);

            new_element.addEventListener('click', window.cleeverCheckouthandleClick)
            if (i == 5) {
                clearInterval(interval)
            }
        }, 2000)


        
    })
    
    waitForElm(".rebuy-cart__flyout-actions button").then((el) => {
        if (!document.body.classList.contains('cleever-on')) {
            return
        }
        const div = document.createElement('div');
        div.style.width = "100%";
        div.innerHTML = `
        <cleever-cta-discount style="padding: 14px;">
            <span class="cleever-visible-text" slot="text" style=" padding: 0 8px;font-size: 15px;">Get Free Shipping</span>
            ${el.outerHTML}
        </cleever-cta-discount>
        <div class="cleever-divider" style="height: 1px; background-color: #D6D6D6; width: 100%; margin: 20px 0 4px 0;"></div>
        <cleever-not-eligible-discount>

            <span class="cleever-visible-text" slot="text">NOT eligible for Free Shipping</span>
            <cleever-fake-additional-checkouts size="small"  paypal shop-pay google-pay apple-pay klarna></cleever-fake-additional-checkouts>
        </cleever-not-eligible-discount>`
        el.replaceWith(div)
        
        
        div.querySelector('button').addEventListener('click', window.cleeverCheckouthandleClick)
    })

    

    waitForElm('#rebuy-cart__progress-bar-meter-label').then((container) => {
        if (!document.body.classList.contains('cleever-on')) {
            return
        }
        const handleThreshold = () => {
            console.log('running threshold')
            const complete = container.textContent.toUpperCase().includes('CONGRATS');
            /**
             * @type {HTMLSpanElement[]}
             */
            const notEligibleElementTexts = document.querySelectorAll(
                'cleever-not-eligible-discount span'
            );
            console.log({ complete });
            
            for (const notEligibleElementText of notEligibleElementTexts) {
                notEligibleElementText.hidden = complete;
            }
        };
        handleThreshold();
        console.log('observing')
        console.log('container')
        const observer = new MutationObserver((mutations) => {
            handleThreshold();
        });

        observer.observe(container, {
            childList: true,
            subtree: true,
        });
    })
  
})();


/* ── HEXXEE Add to Cart Animation ── */
(function() {
  var ADDED_TEXT = '✓ ADDED!';
  var RESET_DELAY = 1500;

  function animateATC(btn) {
    var originalText = btn.textContent;
    var originalBg = btn.style.backgroundColor;

    btn.classList.add('hx-atc-press');
    setTimeout(function() { btn.classList.remove('hx-atc-press'); }, 200);

    setTimeout(function() {
      btn.textContent = ADDED_TEXT;
      btn.classList.add('hx-atc-added');

      pulseCartIcon();

      setTimeout(function() {
        btn.textContent = originalText;
        btn.classList.remove('hx-atc-added');
      }, RESET_DELAY);
    }, 1000);
  }

  function pulseCartIcon() {
    var icon = document.querySelector('.Header__CartIcon, .Header__CartCount, [href="/cart"] svg');
    if (!icon) return;
    icon.classList.add('hx-cart-pulse');
    icon.addEventListener('animationend', function() {
      icon.classList.remove('hx-cart-pulse');
    }, { once: true });
  }

  document.addEventListener('product:added', function(e) {
    var btn = document.querySelector('.ProductForm__AddToCart, button[name="add"]');
    if (btn) animateATC(btn);
  });
})();


/* ── HEXXEE Quick Add Card Animation ── */
(function() {
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.hx-quick-add-btn');
    if (!btn) return;

    // Pulse
    btn.classList.add('hx-qa-pulse');
    btn.addEventListener('animationend', function() {
      btn.classList.remove('hx-qa-pulse');
    }, { once: true });

    // After quickshop fires and item is added, show confirmation
    var originalText = btn.textContent;
    document.addEventListener('product:added', function() {
      btn.textContent = '✓ ADDED!';
      btn.classList.add('hx-qa-added');
      setTimeout(function() {
        btn.textContent = originalText;
        btn.classList.remove('hx-qa-added');
      }, 1500);
    }, { once: true });
  });
})();


/* ── HEXXEE Quickshop — Close button + Swatch swap + ATC animation ── */
(function() {
  // Close button
  document.addEventListener('click', function(e) {
    var closeBtn = e.target.closest('.hx-qs__close');
    if (!closeBtn) return;
    var popup = closeBtn.closest('.hx-qs');
    if (popup) {
      popup.classList.remove('show');
      document.querySelector('.PageOverlay').classList.remove('is-visible');
      document.querySelector('html').classList.remove('no-scroll');
    }
  });

  // Swatch image swap + colour name update
  document.addEventListener('change', function(e) {
    var radio = e.target.closest('.hx-qs__swatch-radio');
    if (!radio) return;

    var popup = radio.closest('.hx-qs');
    if (!popup) return;

    var img = popup.querySelector('.hx-qs__image');
    var variantImg = radio.getAttribute('data-variant-image');
    var colorName = popup.querySelector('.hx-qs__color-name');

    if (colorName) colorName.textContent = radio.value;

    if (img && variantImg) {
      img.classList.add('hx-fade');
      setTimeout(function() {
        img.src = variantImg;
        img.classList.remove('hx-fade');
      }, 250);
    }
  });

  // Quickshop ATC animation
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.hx-qs__atc');
    if (!btn || btn.disabled) return;

    document.addEventListener('product:added', function() {
      var span = btn.querySelector('span') || btn;
      var orig = span.textContent;
      span.textContent = '✓ ADDED!';
      btn.classList.add('hx-atc-added');
      setTimeout(function() {
        span.textContent = orig;
        btn.classList.remove('hx-atc-added');
      }, 1500);
    }, { once: true });
  });

  // Quantity buttons in quickshop
  document.addEventListener('click', function(e) {
    var action = e.target.closest('[data-action="decrease-quantity"], [data-action="increase-quantity"]');
    if (!action) return;
    var wrapper = action.closest('.hx-qs__qty');
    if (!wrapper) return;
    var input = wrapper.querySelector('input');
    if (!input) return;
    var val = parseInt(input.value) || 1;
    if (action.dataset.action === 'increase-quantity') {
      input.value = val + 1;
    } else {
      input.value = Math.max(1, val - 1);
    }
  });
})();


/* ── HEXXEE Fix: mobile menu currency popover can't scroll ──
   The popover lives inside the sliding drawer, whose CSS transform makes it
   the containing block — the popover gets clipped to the drawer and its list
   can't scroll. On first open we reparent the popover to <body> (the CSS in
   sidebar-menu.liquid then pins it as a bottom sheet). The country buttons
   carry form="localization_form_footer" so they still submit the
   localization form after being moved out of it. ── */
(function() {
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.hx-currency-btn');
    if (!btn) return;
    var pop = document.getElementById(btn.getAttribute('aria-controls'));
    if (pop && pop.parentElement !== document.body) {
      document.body.appendChild(pop);
    }
  }, true);
})();
